import { i18n } from '@/i18n';
import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import dayjs from 'dayjs';

// 通用配置
export * from './base-config';

export function getActBaseConfig() {
  const startTime = '2022/09/01 00:00:00';
  const endTime = '2022/09/10 23:59:59';

  // 捐赠次数生效时间
  const isConfEffectTime =
    dayjs(getServerTime()).isAfter(dayjs(startTime)) && dayjs(getServerTime()).isBefore(dayjs(endTime));
  // 99 公益日 ui 生效时间
  const isUiEffectTime = dayjs(getServerTime()).isBefore(dayjs(endTime));

  const uiConf = {
    // 是否是日常活动
    isDailyActivity: true,
    // 头图
    headerLogo: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20221208163934/header-ssv.png',
    // 卡通图片
    cartonLogo: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20220512132300/carton.png',
    // 卡片背景
    cardBg: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20220512134158/card-bg.png',
    // ngo 模块标题
    headerTitle: i18n('我的成就'),
  };
  const donationConf = {
    // 捐赠上限
    donationLimit: 1,
    // 是否加码捐赠
    isMoreDonation: false,
  };

  // 基础配置
  let baseConf = {
    ...uiConf,
    ...donationConf,
  };

  // 如果 ui 生效了
  if (isUiEffectTime) {
    baseConf = {
      ...baseConf,
      // 是否是日常活动
      isDailyActivity: false,
      // 头图
      headerLogo: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20220823161942/header.png',
      // 卡通图片
      cartonLogo: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20220823194638/carton.png',
      // 卡片背景
      cardBg: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20220823223811/card-bg.png',
      // ngo 模块标题
      headerTitle: i18n('我的公益印花'),
    };
  }
  // 如果配置生效了
  if (isConfEffectTime) {
    baseConf = {
      ...baseConf,
      // 捐赠上限
      donationLimit: 2,
      // 是否加码捐赠
      isMoreDonation: true,
    };
  }

  console.log('baseConf: ', baseConf);
  return baseConf;
}
